// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3EWiL","comment":"styles_comment__2YBg-"};